import React, { useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Button,
  Alert,
  CircularProgress,
  Container,
  Stack,
} from '@mui/material';
import { Google } from '@mui/icons-material';
import { signInWithGoogle } from '../firebase';

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleGoogleSignIn = async () => {
    setLoading(true);
    setError(null);
    
    try {
      await signInWithGoogle();
    } catch (error) {
      console.error('Sign in error:', error);
      setError('Failed to sign in. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 4,
        }}
      >
        <Card
          elevation={8}
          sx={{
            width: '100%',
            maxWidth: 400,
            p: 2,
          }}
        >
          <CardContent>
            <Stack spacing={3} alignItems="center">
              {/* Error Message */}
              {error && (
                <Alert severity="error" sx={{ width: '100%' }}>
                  {error}
                </Alert>
              )}

              {/* Google Sign In Button */}
              <Button
                variant="contained"
                size="large"
                fullWidth
                onClick={handleGoogleSignIn}
                disabled={loading}
                startIcon={
                  loading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <Google />
                  )
                }
                sx={{
                  py: 1.5,
                  bgcolor: '#4285f4',
                  '&:hover': {
                    bgcolor: '#3367d6',
                  },
                  '&:disabled': {
                    bgcolor: 'rgba(66, 133, 244, 0.5)',
                  },
                }}
              >
                {loading ? 'Signing in...' : 'Sign in with Google'}
              </Button>
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Login;